import { Button, Drawer } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAllSetting } from '../../service/base';
import { CONST_SITE } from '../../utils/common/const';
// import CountDownFinal from './CountDownFinal';

const navItems = [
  { name: 'TRANG CHỦ', href: '#' },
  { name: 'DỰ ĐOÁN', href: '/' },
  { name: 'THỂ LỆ', href: '/rule' },
  { name: 'KẾT QUẢ', href: '/prize-structure' }
];

const MENU_ITEM_BG = '/assets/images/header/menu_item_bg.png';

const mobileNavButtons = [
  { name: 'DỰ ĐOÁN', href: '/', type: 'link' },
  { name: 'THỂ LỆ', href: '/rule', type: 'link' },
  { name: 'KẾT QUẢ', href: '/prize-structure', type: 'link' },
  { name: 'LỊCH SỬ', href: '/history', type: 'link' }
];

const Header = () => {
  const location = useLocation();
  const activeNav = location.pathname;
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const mounted = useRef(false);
  const [isShowMenu, setIsShowMenu] = useState(false);

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({
          site: CONST_SITE.OPEN88
        });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
          // Update the home link in navItems
          navItems[0].href = settingsMap.link_home || '/';
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <div className="w-full">
      <div
        className="w-full max-w-[1200px] mx-auto mt-2 md:mt-8 rounded-[24px] md:rounded-[40px]
            flex flex-row items-center 
            bg-[#FFFFFF]
            px-[12px] md:px-[30px]
            h-[80px] gap-[8px]"
        style={{
          boxShadow: 'inset 0px 0px 10px 0px #F36523',
          boxSizing: 'border-box'
        }}
      >
        <div className="flex lg:hidden justify-start items-center">
          <Drawer
            placement="left"
            onClose={() => setIsShowMenu(false)}
            open={isShowMenu}
            closeIcon={null}
            width={260}
            bodyStyle={{ padding: 0, position: 'relative' }}
            style={{
              // Hide scrollbar for the Drawer
              overflow: 'auto',
              scrollbarWidth: 'none', // For Firefox
              msOverflowStyle: 'none' // For IE, Edge
            }}
            // For Ant Design Drawer: pass className to customize scrollbar for inner content
            className="drawer-hide-scrollbar"
          >
            {/* Inline scrollbar-hide CSS for injected content */}
            <style>
              {`
                  .drawer-hide-scrollbar {
                    scrollbar-width: none !important;        /* Firefox */
                    -ms-overflow-style: none !important;     /* IE and Edge */
                  }
                  .drawer-hide-scrollbar::-webkit-scrollbar {
                    display: none !important;                /* Chrome, Safari and Opera */
                    width: 0 !important;
                    background: transparent !important;
                  }
                `}
            </style>
            {/* Logo on Top */}
            <div
              className="flex items-center justify-center w-full py-6 border-b border-gray-200"
              style={{ background: '#FFFFFF' }}
            >
              <Link to="/" onClick={() => setIsShowMenu(false)}>
                <img
                  src="/assets/images/header/logo.png"
                  alt="Logo"
                  className="h-[40px] w-auto object-contain mx-auto"
                />
              </Link>
            </div>
            {/* Close Button X */}
            <button
              onClick={() => setIsShowMenu(false)}
              className="absolute top-3 right-3 z-10 hover:opacity-80 transition-opacity"
              aria-label="Đóng menu"
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: 0
              }}
            >
              <img
                src="/assets/images/header/close.png"
                alt="Close"
                className="w-8 h-8 object-contain"
                style={{
                  filter:
                    'brightness(0) saturate(100%) invert(47%) sepia(95%) saturate(1752%) hue-rotate(349deg) brightness(97%) contrast(93%)'
                }}
              />
            </button>
            {/* Hide scrollbar for this menu list as well */}
            <div
              className="flex flex-col h-full"
              style={{ background: '#FFFFFF', overflow: 'auto' }}
            >
              <Link
                to="/"
                onClick={() => setIsShowMenu(false)}
                className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
              >
                DỰ ĐOÁN
              </Link>
              <Link
                to="/rule"
                onClick={() => setIsShowMenu(false)}
                className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
              >
                THỂ LỆ
              </Link>
              <Link
                to="/prize-structure"
                onClick={() => setIsShowMenu(false)}
                className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
              >
                KẾT QUẢ
              </Link>
              <Link
                to="/history"
                onClick={() => setIsShowMenu(false)}
                className="flex items-center px-5 py-8 font-bold text-xl w-full text-[#f27121] hover:bg-[#f27121] hover:text-white transition-colors"
              >
                LỊCH SỬ
              </Link>
              <Link
                to={settings.link_login}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center px-5 py-4 f27121 font-bold text-xl text-[#f27121] transition-colors"
                onClick={() => setIsShowMenu(false)}
              >
                Đăng nhập
              </Link>
              <Link
                to={settings.link_register}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
                onClick={() => setIsShowMenu(false)}
              >
                Đăng ký
              </Link>
            </div>
          </Drawer>
          <Button type="link" onClick={() => setIsShowMenu(true)} style={{ color: '#f27121' }}>
            <img
              src="/assets/images/header/menu.png"
              alt=""
              className="h-[32px] w-[32px] md:w-auto object-contain mt-1"
              style={{
                filter:
                  'brightness(0) saturate(100%) invert(47%) sepia(95%) saturate(1752%) hue-rotate(349deg) brightness(97%) contrast(93%)'
              }}
            />
          </Button>
        </div>
        <div className="flex justify-center items-center shrink-0">
          <Link key={navItems[0].name} to={navItems[0].href || '/'}>
            <img
              src="/assets/images/header/logo.png"
              alt=""
              className="h-[32px] md:h-[63px] mt-2 md:mt-0 w-auto object-contain"
            />
          </Link>
        </div>
        <div className="hidden flex justify-center items-center flex-1">
          <div className="lg:flex hidden flex-row justify-center items-center w-full gap-3 lg:gap-6">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-center text-[14px] px-4 py-1.5 rounded-lg lg:text-[15px] xl:text-[16px] font-semibold ${
                  activeNav === item.href
                    ? 'text-[#FFF] bg-[#f27121]'
                    : 'text-[#3E4C5C] bg-transparent'
                } ${item.name === 'TRANG CHỦ' ? 'hidden md:block' : ''}`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/history"
              className={`text-center text-[14px] px-4 py-1.5 rounded-lg lg:text-[15px] xl:text-[16px] font-semibold ${
                activeNav === '/history'
                  ? 'text-[#FFF] bg-[#f27121]'
                  : 'text-[#3E4C5C] bg-transparent'
              }`}
            >
              LỊCH SỬ
            </Link>
          </div>
        </div>
        <div className="flex flex-col items-end justify-center shrink-0 ml-auto min-w-0">
          <div className="hidden md:flex flex-row justify-end gap-4 h-full">
            {/* Login Button */}
            <Link
              to={settings.link_login}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center h-[34px] w-[119px] rounded-[50px] font-bold text-[14px] leading-[20px] text-center whitespace-nowrap text-[#ffffff]"
              style={{
                background: '#FF6F20',
                boxShadow: 'inset 0px 1px 2px 0px #FEAD00'
              }}
            >
              ĐĂNG NHẬP
            </Link>

            {/* Register Button */}
            <div
              className="flex bg-[#FFFFFF] flex-col items-start rounded-[50px] w-[119px] h-[34px]"
              style={{ border: '1px solid #FF6F20' }}
            >
              <Link
                to={settings.link_register}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center rounded-[50px] w-full h-full font-bold text-[14px] leading-[20px] text-center whitespace-nowrap text-[#FF6F20] relative overflow-hidden"
              >
                ĐĂNG KÝ
              </Link>
            </div>
          </div>
          <div
            className="md:hidden flex bg-[#feb562] mt-1 flex-col items-end p-px rounded-full w-auto max-w-full h-[36px] ml-auto"
            style={{
              boxShadow:
                '0px 12.522px 10.017px 0px rgba(255, 118, 20, 0.13), 0px 6.65px 5.32px 0px rgba(255, 118, 20, 0.11), 0px 2.767px 2.214px 0px rgba(255, 118, 20, 0.07)'
            }}
          >
            <Link
              to={navItems[0].href || '/'}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center px-[12px] py-[4px] rounded-full h-full font-bold text-[14px] leading-[24px] text-center whitespace-nowrap text-white cursor-pointer relative overflow-hidden"
              style={{
                background: 'linear-gradient(to bottom, rgba(255, 214, 179, 0), #df630b)',
                boxShadow: 'inset 0px 4px 4px 0px rgba(255, 191, 0, 0.16)'
              }}
            >
              Trang Chủ
            </Link>
          </div>
        </div>
      </div>
      <div className="w-full h-auto flex justify-center items-center">
        <img
          src="/assets/images/header/banner.png"
          alt=""
          className="sm:block hidden w-auto max-w-[1000px] h-[100px] md:h-[191px] object-contain py-2 flex"
        />
        <img
          src="/assets/images/header/banner_mb.png"
          alt=""
          className="sm:hidden block w-auto max-w-[1000px] h-[100px] md:h-[191px] object-contain py-2 flex"
        />
      </div>

      <div className="flex justify-center items-center w-full px-2 mb-3">
        <div className="w-full overflow-x-auto overflow-y-hidden scrollbar-hide">
          <div className="flex flex-row items-center justify-center gap-[2px] md:gap-[10px] py-2 md:py-3 min-w-max mx-auto md:px-1">
            {mobileNavButtons.map((item) => {
              const isActive = item.href === '/' ? activeNav === '/' : activeNav === item.href;
              const labelClass = [
                'text-center font-extrabold text-white whitespace-nowrap px-2 sm:px-3 select-none',
                'text-[11px] sm:text-[15px] md:text-[17px] leading-tight tracking-tight',
                isActive ? 'brightness-110' : ''
              ]
                .filter(Boolean)
                .join(' ');
              const frameClass =
                'inline-flex h-[26px] md:h-[55px] min-w-0 flex-1 max-w-[212px] shrink basis-0 items-center justify-center bg-contain bg-center bg-no-repeat';

              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`${frameClass} no-underline`}
                  style={{
                    backgroundImage: `url(${MENU_ITEM_BG})`,
                    textShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)'
                  }}
                >
                  <span className={labelClass}>{item.name}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
